import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative overflow-hidden bg-acid text-ink"
    >
      <svg
        viewBox="0 0 200 200"
        className="pointer-events-none absolute -right-16 top-1/2 hidden w-[28rem] -translate-y-1/2 opacity-[0.08] lg:block"
        aria-hidden="true"
      >
        <circle cx="70" cy="100" r="62" stroke="#0A0B0D" strokeWidth="5" fill="none" />
        <circle cx="130" cy="100" r="62" stroke="#0A0B0D" strokeWidth="5" fill="none" />
        <circle cx="100" cy="52" r="62" stroke="#0A0B0D" strokeWidth="5" fill="none" />
      </svg>
      <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
        <Reveal>
          <SectionLabel index="CH.01" dark>
            The Triple O Point of View
          </SectionLabel>
        </Reveal>
        <Reveal delay={0.12}>
          <p
            data-testid="manifesto-statement"
            className="mt-10 max-w-5xl font-display text-2xl font-bold leading-[1.3] tracking-tight sm:text-4xl sm:leading-[1.2] lg:text-5xl lg:leading-[1.15]"
          >
            Your product earns the shelf. Your presence earns the room. We build places, objects
            and moments people remember.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
